import { Injectable } from '@angular/core';
import { AppConfigService } from '../../app-config.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Store } from '@ngxs/store';
import { ModifierParcours, PersonneState } from '../personne.state';
import { GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES, GTM_PUSH_CATEGORY } from '../modeles/variables';
import { GtmService } from './gtm.service';

@Injectable({
  providedIn: 'root'
})
export class ClickToCallBackService {
  private readonly BASE_URL = 'https://rappel.desjardins.com/#/';
  private readonly DESKTOP_URL_SUFFIX_FR = `dcom-pleine-page`;
  private readonly DESKTOP_URL_SUFFIX_EN = `dcom-full-page`;
  private readonly MOBILE_WEB_URL_SUFFIX_FR = `services-mobiles`;
  private readonly MOBILE_WEB_URL_SUFFIX_EN = `mobile-services`;
  private readonly STRUCT_PARAMETER = ['VPA', 'DPCCCSC', 'Financement'];
  private readonly DEST_PARAMETER = 'FIN_ParcoursHab';
  private readonly DA_PARAMETER = 'P';
  private readonly SOURCE_PARAMETER = 'https://maison.mouv.desjardins.com/';

  private _rawMobileUrl = '';
  private _rawDesktopUrl = '';

  constructor(
    private readonly _appConfigService: AppConfigService,
    private readonly _domSanitizer: DomSanitizer,
    private readonly _store: Store,
    private readonly _gtm: GtmService
  ) {
    this.buildUrls();
  }

  get url(): SafeUrl {
    return this._domSanitizer.bypassSecurityTrustUrl(this._rawUrl);
  }

  private get _rawUrl(): string {
    return PersonneState.detectCanal() === 'Mobile' ? this._rawMobileUrl : this._rawDesktopUrl;
  }

  private buildUrls() {
    const isFr = this._appConfigService.langue === 'fr';
    const urlParameters = `?struct=${encodeURI(JSON.stringify(this.STRUCT_PARAMETER))}&dest=${this.DEST_PARAMETER}&da=${
      this.DA_PARAMETER
    }&source=${encodeURIComponent(this.SOURCE_PARAMETER)}`;
    this._rawDesktopUrl = `${this.BASE_URL}${
      isFr ? this.DESKTOP_URL_SUFFIX_FR : this.DESKTOP_URL_SUFFIX_EN
    }${urlParameters}`;

    this._rawMobileUrl = `${this.BASE_URL}${
      isFr ? this.MOBILE_WEB_URL_SUFFIX_FR : this.MOBILE_WEB_URL_SUFFIX_EN
    }${urlParameters}`;
  }

  addDemandeSupport() {
    const codePage = this._store.selectSnapshot(state => state.navigation.codePage);
    const codeSection = this._store.selectSnapshot(state => state.navigation.codeSection);
    this._store.dispatch(new ModifierParcours(codeSection, codePage));
  }

  openInNewTab() {
    window.open(this._rawUrl, '_blank');
  }
}
